module.exports = __webpack_public_path__ + "media/05.45e0c341.mp3";